import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  background-image: linear-gradient(164deg, #fff0e2 50%, #ffffff);

  .content-faq-page {
    padding: 50px 0 80px 0;
    max-width: 900px;
    margin: auto;
  }

  .title-block {
    text-align: center;
    margin-bottom: 20px;

    .ant-typography {
      color: ${theme.darkRed};
    }
  }

  .sub-title-block {
    text-align: center;
    margin-bottom: 50px;

    .ant-typography {
      color: ${theme.gray};
    }
  }

  .category-block {
    background-color: ${theme.white};
    border-radius: 10px;
    box-shadow: 2px 5px 10px 0 rgba(0, 0, 0, 0.14);
    padding: 25px 16px;
    text-align: center;
    cursor: pointer;

    .text-category-name {
      color: ${theme.darkRed};
    }

    .icon {
      width: 30px;
    }
  }

  .faq-content {
    margin-top: 60px;
    min-height: 60vh;
    background-color: ${theme.white};
    border-radius: 10px;
    box-shadow: 2px 5px 10px 0 rgba(0, 0, 0, 0.14);
    padding: 40px 16px;

    .title-faq {
      text-align: center;
      margin-bottom: 30px;

      .text-title-faq {
        color: ${theme.darkRed};
      }
    }

    .ant-collapse-item {
      margin-bottom: 10px;
      border-bottom: 0;

      .ant-collapse-header {
        background-color: #f2f2f2;
        border-radius: 10px;

        .header-custom {
          .ant-typography {
            color: ${theme.darkRed};
          }
        }
      }
    }
  }
`
